module.exports = __webpack_public_path__ + "img/processo_fisico.d25287ec.png";